import BillingDetail from './BillingDetail';

export default BillingDetail;
